// removed by extract-text-webpack-plugin
module.exports = {"betBothButton":"_89x00OeSdVvzN8awrTFdy","container":"_19FGFU1pPFsazK3eyiRjmE","arrowRight":"_3L6iF-TynMZLnQ6ORD8Xyh","arrowLeft":"oZIKvWIh-YJS8e60lvknV","marketText":"_3ifvRDYqop4FWf0usVaOtB","marketType":"hh0X2vU8eDtOY8zmS2gPQ","wrapper":"waWsFkWCZLTsPN5Mkmv3m","disabled":"_3YnIQveRTVKeqmc7DzTSQS","disabledArrowLeft":"_2bSXFoHCES1CBKu2KUgzOS","disabledArrowRight":"_1JFp35NUFepjJK4IT3dtKG","disabledContainer":"_1W1qdTCrTOjsixa5sMDN6l","buttonCustomStyle":"_32tixVJTvNOB1jh503hsUB"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/betBothCardSoccer3.css
// module id = 799
// module chunks = 0